"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolloutStrategyFieldType = void 0;
var RolloutStrategyFieldType;
(function (RolloutStrategyFieldType) {
    RolloutStrategyFieldType["String"] = "STRING";
    RolloutStrategyFieldType["SemanticVersion"] = "SEMANTIC_VERSION";
    RolloutStrategyFieldType["Number"] = "NUMBER";
    RolloutStrategyFieldType["Date"] = "DATE";
    RolloutStrategyFieldType["Datetime"] = "DATETIME";
    RolloutStrategyFieldType["Boolean"] = "BOOLEAN";
    RolloutStrategyFieldType["IpAddress"] = "IP_ADDRESS";
})(RolloutStrategyFieldType = exports.RolloutStrategyFieldType || (exports.RolloutStrategyFieldType = {}));
//# sourceMappingURL=rollout-strategy-field-type.js.map